import no_sound from '@/assets/images/no_sound.png';
import sound from '@/assets/images/sound.png';
import { useTranslation } from '@/utils/util';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang, useNavigate } from '@umijs/max';
import { Badge, Button, Dropdown, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';

export type SiderTheme = 'light' | 'dark';

export const postLocalesData = () => [
  {
    lang: 'zh-CN',
    languageType: 'zh_CN',
    label: '简体中文',
    icon: '🇨🇳',
    title: '语言',
  },
  {
    lang: 'en-US',
    languageType: 'en_US',
    label: 'English',
    icon: '🇺🇸',
    title: 'Language',
  },
];

export const SelectLang = () => {
  const handleChange = (item: any) => {
    const localeItem = postLocalesData().find((locale) => locale.lang === item.key);
    if (localeItem) {
      localStorage.setItem('umi_locale', localeItem.lang); // umi国际化
      // header里的国际化
      localStorage.setItem('lang', localeItem.languageType);
      localStorage.setItem('defaultLang', localeItem.languageType);
      window.location.reload();
    }
  };

  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
      reload={false}
      postLocalesData={postLocalesData}
      onItemClick={handleChange}
    />
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};

export const Tutorial = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        // const location = useLocation();
        // const pathname = location.pathname; // 获取当前路由的路径名
        // const search = location.search; // 获取URL的查询字符串部分
        const domain = window.location.origin;
        window.open(domain + '/docs/docs/category/仪表盘/');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};
export const TimezoneSelector = () => {
  const timezones = [
    'UTC-12',
    'UTC-11',
    'UTC-10',
    'UTC-9:30',
    'UTC-09',
    'UTC-08',
    'UTC-07',
    'UTC-06',
    'UTC-05',
    'UTC-04',
    'UTC-03',
    'UTC-02',
    'UTC-01',
    'UTC-00',
    'UTC+00',
    'UTC+01',
    'UTC+02',
    'UTC+03',
    'UTC+03:30',
    'UTC+04',
    'UTC+04:30',
    'UTC+05',
    'UTC+05:30',
    'UTC+05:45',
    'UTC+06',
    'UTC+07',
    'UTC+08',
    'UTC+09',
    'UTC+10',
    'UTC+10:30',
    'UTC+11',
    'UTC+12',
    'UTC+12:45',
    'UTC+13',
    'UTC+13:45',
    'UTC+14',
  ];

  useEffect(() => {
    localStorage.setItem('timezone', localStorage.getItem('timezone') || 'UTC+08:00');
  }, []);

  const options = timezones.map((item) => {
    const hasMaohao = item.includes(':');
    // 如果不包含 :，则添加:00
    const value = hasMaohao ? item : `${item}:00`;
    return { label: item, value };
  });

  const handleChange = (val: string) => {
    localStorage.setItem('timezone', val);
    window.location.reload();
  };

  return (
    <div>
      <Select
        style={{ width: 120 }}
        allowClear={false}
        onChange={handleChange}
        disabled
        options={options}
        defaultValue={localStorage.getItem('timezone') || 'UTC+08:00'}
      />
    </div>
  );
};

